import React, { ReactNode, useContext } from "react";
import { PDFDesignerProviderValue, PhoenixPDFsDesignerContext } from "./PhoenixPdfDesignerContext";
import { MCard } from "components/Shared";
import { KeyValueOriginal, MCardField } from "components/Shared/MCard";
import { setObjectValue } from "components/Shared/Functions";
import { DATA_TYPE_BOOLEAN, DATA_TYPE_DROPDOWN2 } from "typeConstants/dataTypes";

const PhoenixPdfDesignerProps = () => {

  const context = useContext<PDFDesignerProviderValue>(PhoenixPDFsDesignerContext);
  const { selectedLabel } = context;

  let returnNode: ReactNode;

  if (!selectedLabel) {
    returnNode = <div>Select an Element...</div>;
  }
  else {
    const onPropertyEdit = (changeArray: KeyValueOriginal[]) => {
      changeArray.forEach(la => {
        setObjectValue(selectedLabel, la.key, la.value);
      });

      context.refreshPdfDef("pdf edited");
    };

    let typeOptions = [
      { label: "TableCell", value: "TableCell" },
      { label: "TextArea", value: "TextArea" },
    ];

    let propertiesCardFields: MCardField[] = [
      { key: "type", label: "Control Type", dataType: DATA_TYPE_DROPDOWN2, dataTypeOptions: { options: typeOptions }, value: typeOptions.find(o => o.value === selectedLabel.type) },
      { key: "name", label: "Label" },
      { key: "properties.hide", label: "Hide", dataType: DATA_TYPE_BOOLEAN },
      { key: "properties.hideNullOrEmpty", label: "Hide If Blank", dataType: DATA_TYPE_BOOLEAN },
    ];

    if(selectedLabel.type == "TableCell" || selectedLabel.type == "TextArea" || selectedLabel.type == "Label")
    {
      propertiesCardFields.push(
        { key: "properties.parseAsBoolean", label: "Display as Boolean", dataType: DATA_TYPE_BOOLEAN },
        { key: "properties.unitsPrefix", label: "Units Prefix" },
        { key: "properties.unitsSuffix", label: "Units Suffix"  },
      )
    }

    propertiesCardFields.forEach(f => {
      if (f.value === undefined && f.key) f.value = f.key.split(".").reduce((acc, val) => acc ? acc[val] : undefined, selectedLabel);
    });

    returnNode = 
      (<MCard
        key={`${context.selectedLabel.id}`}
        onlyEditable
        onEditChanged={onPropertyEdit}
        title="Properties"
        fields={propertiesCardFields}
      />);
  }

  return (
    <div className="designer-props">
      {returnNode}
    </div>
  );
};

export default PhoenixPdfDesignerProps;
